<template>
  <div>
    <a-card :bordered="false" class="header-solid mb-24" style="max-width:720px">
      <template #title>
        <h5 class="font-semibold m-0">系统设置 · Cloudflare</h5>
        <p class="text-muted m-0" style="font-size:13px">配置 Cloudflare 凭据,用于自动建 zone、隐藏源站 IP。凭据只存服务端。</p>
      </template>

      <a-descriptions :column="1" size="small" class="mb-16" bordered>
        <a-descriptions-item label="当前状态">
          <a-tag :color="cur.configured ? 'green' : 'red'">{{ cur.configured ? '已配置' : '未配置' }}</a-tag>
          <span v-if="cur.configured" class="text-muted">密钥 {{ cur.api_key_masked }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="鉴权方式">{{ cur.auth_mode || '-' }}</a-descriptions-item>
        <a-descriptions-item label="Account ID">{{ cur.account_id || '-' }}</a-descriptions-item>
        <a-descriptions-item label="连通性">
          <a-tag v-if="testResult === 'ok'" color="green">连接正常</a-tag>
          <a-tag v-else-if="testResult === 'fail'" color="red">连接失败</a-tag>
          <span v-else class="text-muted">未测试</span>
          <a-button size="small" style="margin-left:8px" :loading="testing" @click="doTest">测试连接</a-button>
        </a-descriptions-item>
      </a-descriptions>

      <a-form :form="form" layout="vertical" @submit.prevent="save">
        <a-form-item label="鉴权方式">
          <a-select v-model="authMode" style="width:220px">
            <a-select-option value="global_key">Global API Key(邮箱+Key)</a-select-option>
            <a-select-option value="token">API Token(Bearer)</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Account ID">
          <a-input v-model="accountId" placeholder="32位十六进制 Account ID" />
        </a-form-item>
        <template v-if="authMode === 'global_key'">
          <a-form-item label="账号邮箱">
            <a-input v-model="accountEmail" placeholder="Cloudflare 账号邮箱" />
          </a-form-item>
          <a-form-item label="Global API Key">
            <a-input-password v-model="apiKey" placeholder="留空则不修改" />
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item label="API Token">
            <a-input-password v-model="apiToken" placeholder="留空则不修改" />
          </a-form-item>
        </template>
        <a-button type="primary" :loading="saving" @click="save">保存并测试</a-button>
      </a-form>
    </a-card>

    <a-card :bordered="false" class="header-solid" style="max-width:720px">
      <template #title>
        <h5 class="font-semibold m-0">系统设置 · Telegram 到期提醒</h5>
        <p class="text-muted m-0" style="font-size:13px">配置 Telegram 机器人,用于给客户发到期提醒。客户在客户端自助绑定。</p>
      </template>
      <a-descriptions :column="1" size="small" class="mb-16" bordered>
        <a-descriptions-item label="当前状态">
          <a-tag :color="tg.valid ? 'green' : (tg.configured ? 'orange' : 'red')">
            {{ tg.valid ? '已配置且有效' : (tg.configured ? '已配置(Token无效)' : '未配置') }}
          </a-tag>
          <span v-if="tg.bot_token_masked" class="text-muted">Token {{ tg.bot_token_masked }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="机器人">
          <span v-if="tg.bot_username">@{{ tg.bot_username }}
            <a :href="'https://t.me/' + tg.bot_username" target="_blank" style="margin-left:8px">打开</a>
          </span>
          <span v-else class="text-muted">-</span>
        </a-descriptions-item>
      </a-descriptions>
      <a-alert type="info" show-icon class="mb-16"
        message="如何获取 Bot Token"
        description="在 Telegram 搜索 @BotFather → 发送 /newbot → 按提示创建 → 复制它给的 Token 填到下面。" />
      <a-form layout="vertical">
        <a-form-item label="Bot Token">
          <a-input-password v-model="botToken" placeholder="123456789:AA...（留空则不修改）" />
        </a-form-item>
        <a-button type="primary" :loading="tgSaving" @click="saveTg">保存并验证</a-button>
        <a-button style="margin-left:10px" :loading="tgValidating" @click="validateTg">验证并清理无效绑定</a-button>
      </a-form>
      <a-alert type="info" show-icon class="mt-12"
        message="关于绑定安全"
        description="客户绑定时会先收到测试消息,发送成功才算绑定,乱填的 ID 无法保存。点上面按钮可随时用 getChat 复检所有绑定(不打扰用户),自动清除失效/无效的绑定。" />
    </a-card>

    <a-card :bordered="false" class="header-solid mt-24" style="max-width:720px">
      <template #title>
        <h5 class="font-semibold m-0">系统设置 · 管理员到期提醒</h5>
        <p class="text-muted m-0" style="font-size:13px">每天 09:20 把「即将到期的客户」汇总发到你自己的 Telegram,方便你主动去催续费。</p>
      </template>
      <a-descriptions :column="1" size="small" class="mb-16" bordered>
        <a-descriptions-item label="当前状态">
          <a-tag :color="ar.enabled && ar.configured ? 'green' : (ar.configured ? 'orange' : 'red')">
            {{ ar.enabled && ar.configured ? '已开启' : (ar.configured ? '已配置(未开启)' : '未配置') }}
          </a-tag>
          <span class="text-muted">每天 {{ ar.send_time || '09:20' }} · 提前 {{ ar.days_before || 3 }} 天</span>
        </a-descriptions-item>
        <a-descriptions-item label="机器人">
          <span v-if="ar.bot_username">@{{ ar.bot_username }}
            <a :href="'https://t.me/' + ar.bot_username" target="_blank" style="margin-left:8px">打开</a>
            <span v-if="ar.fallback" class="text-muted" style="margin-left:8px">(复用客户提醒机器人)</span>
          </span>
          <span v-else class="text-muted">-</span>
        </a-descriptions-item>
        <a-descriptions-item label="接收人 ID">
          <span v-if="ar.admin_chat_id">{{ ar.admin_chat_id }}</span>
          <span v-else class="text-muted">未填写</span>
        </a-descriptions-item>
      </a-descriptions>
      <a-alert type="info" show-icon class="mb-16"
        message="怎么填"
        description="1) Bot Token:同上,找 @BotFather 建一个机器人拿 Token;想省事可留空,直接复用上面客户提醒的机器人。2) 你的 User ID:在 Telegram 搜 @userinfobot 发任意消息,它回你的数字 ID。3) 关键:先在 Telegram 里给该机器人发一条 /start,否则机器人无法主动给你发消息。填完先「保存」,再点「发送测试」确认收到。" />
      <a-form layout="vertical">
        <a-form-item label="Bot Token(留空=复用客户提醒机器人 / 不修改)">
          <a-input-password v-model="arToken" placeholder="123456789:AA...（可留空）" />
        </a-form-item>
        <a-form-item label="你的 Telegram User ID">
          <a-input v-model="arChatId" placeholder="纯数字,如 123456789" style="max-width:280px" />
        </a-form-item>
        <a-form-item label="提前几天提醒">
          <a-input-number v-model="arDays" :min="1" :max="30" style="width:120px" />
          <span class="text-muted" style="margin-left:8px">天内到期的客户会被列入</span>
        </a-form-item>
        <a-form-item label="开启每日提醒">
          <a-switch v-model="arEnabled" />
        </a-form-item>
        <a-button type="primary" :loading="arSaving" @click="saveAr">保存</a-button>
        <a-button style="margin-left:10px" :loading="arTesting" @click="testAr">发送测试</a-button>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { dmSettingsGet, dmSettingsSave, dmSettingsTest, dmTgGet, dmTgSave, dmTgValidate, dmAdminRemindGet, dmAdminRemindSave, dmAdminRemindTest } from '../../api/index';

export default {
  data() {
    return {
      form: this.$form ? this.$form.createForm(this) : null,
      cur: {}, testResult: '', testing: false, saving: false,
      authMode: 'global_key', accountId: '', accountEmail: '', apiKey: '', apiToken: '',
      tg: {}, botToken: '', tgSaving: false, tgValidating: false,
      ar: {}, arToken: '', arChatId: '', arDays: 3, arEnabled: false, arSaving: false, arTesting: false,
    };
  },
  created() { this.loadCur(); this.loadTg(); this.loadAr(); },
  methods: {
    loadCur() {
      dmSettingsGet().then(res => {
        this.cur = (res && res.data) ? res.data : {};
        if (this.cur.auth_mode) this.authMode = this.cur.auth_mode;
        if (this.cur.account_id) this.accountId = this.cur.account_id;
        if (this.cur.account_email) this.accountEmail = this.cur.account_email;
      }).catch(() => {});
    },
    doTest() {
      this.testing = true;
      dmSettingsTest().then(res => {
        this.testResult = (res && res.data && res.data.ok) ? 'ok' : 'fail';
      }).catch(() => this.testResult = 'fail').finally(() => this.testing = false);
    },
    loadTg() {
      dmTgGet().then(res => { this.tg = (res && res.data) ? res.data : {}; }).catch(() => {});
    },
    saveTg() {
      if (!this.botToken) { this.$message.warning('请输入 Bot Token'); return; }
      this.tgSaving = true;
      dmTgSave({ bot_token: this.botToken }).then(res => {
        if (res && res.status === 200) { this.$message.success('已保存,机器人 @' + res.data.bot_username); this.botToken = ''; this.loadTg(); }
        else this.$message.error((res && res.message) ? res.message : '保存失败');
      }).catch((e) => this.$message.error((e && e.message) ? e.message : 'Token 无效')).finally(() => this.tgSaving = false);
    },
    loadAr() {
      dmAdminRemindGet().then(res => {
        this.ar = (res && res.data) ? res.data : {};
        this.arChatId = this.ar.admin_chat_id || '';
        this.arDays = this.ar.days_before || 3;
        this.arEnabled = !!this.ar.enabled;
      }).catch(() => {});
    },
    saveAr() {
      if (this.arEnabled && !this.arChatId && !this.ar.admin_chat_id) {
        this.$message.warning('请先填写你的 Telegram User ID'); return;
      }
      this.arSaving = true;
      const payload = { admin_chat_id: this.arChatId, days_before: this.arDays, enabled: this.arEnabled };
      if (this.arToken) payload.bot_token = this.arToken;
      dmAdminRemindSave(payload).then(res => {
        if (res && res.status === 200) { this.$message.success('已保存'); this.arToken = ''; this.loadAr(); }
        else this.$message.error((res && res.message) ? res.message : '保存失败');
      }).catch((e) => this.$message.error((e && e.message) ? e.message : '保存失败')).finally(() => this.arSaving = false);
    },
    testAr() {
      this.arTesting = true;
      dmAdminRemindTest().then(res => {
        if (res && res.status === 200) this.$message.success('已发送,请查看你的 Telegram');
        else this.$message.error((res && res.message) ? res.message : '发送失败');
      }).catch((e) => this.$message.error((e && e.message) ? e.message : '发送失败')).finally(() => this.arTesting = false);
    },
    validateTg() {
      this.tgValidating = true;
      dmTgValidate().then(res => {
        if (res && res.status === 200) {
          const d = res.data || {};
          const n = (d.cleaned || []).length;
          if (n > 0) this.$message.success('复检 ' + d.checked + ' 个绑定,清除 ' + n + ' 个无效:' + d.cleaned.join('、'));
          else this.$message.success('复检 ' + d.checked + ' 个绑定,全部有效,无需清理');
        } else this.$message.error((res && res.message) ? res.message : '验证失败');
      }).catch((e) => this.$message.error((e && e.message) ? e.message : '验证失败')).finally(() => this.tgValidating = false);
    },
    save() {
      const payload = { auth_mode: this.authMode, account_id: this.accountId };
      if (this.authMode === 'global_key') {
        payload.account_email = this.accountEmail;
        if (this.apiKey) payload.api_key = this.apiKey;
      } else {
        if (this.apiToken) payload.api_token = this.apiToken;
      }
      this.saving = true;
      dmSettingsSave(payload).then(res => {
        const ok = res && res.data && res.data.test && res.data.test.ok;
        this.testResult = ok ? 'ok' : 'fail';
        if (ok) this.$message.success('已保存,连接正常');
        else this.$message.warning('已保存,但连接测试失败,请检查凭据');
        this.apiKey = ''; this.apiToken = ''; this.loadCur();
      }).catch(() => this.$message.error('保存失败')).finally(() => this.saving = false);
    },
  },
};
</script>
